module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"instructions":"Uma vez carregada, toque na imagem e segure. Escolha a opção de salvá-la em seu rolo de câmera."}}')
  delete Component.options._Ctor
}
